
import React from 'react';

const ContratCDI = ({
                        nomComplet,
                        titre,
                        cin,
                        cnss,
                        poste,
                        salaire,
                        dateDebut,
                        date,
                        dateNaissance,
                        situationFamille,
                        adresse,
                        tel,
                        salaireLettre ,

                    }) => (
    <div style={{ padding: '20mm', fontFamily: 'Arial, sans-serif', fontSize: '12pt', lineHeight: '1.5' }}>
        <h2 style={{ textAlign: 'center', textDecoration: 'underline' }}>CONTRAT DE TRAVAIL</h2>

        <p><strong>Entre</strong></p>
        <p>
            La société <strong>GO & DEV Delivery Center</strong> au capital de 200 000 DHS, dont le siège social est situé
            Angle Bd 2 Mars et Bd Al Qods - Imm "K" N°5 - 20 150 Casablanca<br/>
            <em>Ci-après dénommée la « société »</em><br/>
            D'une part,
        </p>

        <p><strong>ET</strong></p>
        <p>
            {titre} <strong>{nomComplet}</strong><br/>
            Né le : {dateNaissance || '............'}<br/>
            Situation familiale : {situationFamille || '............'}<br/>
            CIN N°: {cin || '............'}<br/>
            CNSS N° : {cnss || '............'}<br/>
            Demeurant à : {adresse || '..................'}<br/>
            Tel : {tel || '...............'}<br/>
            <em>Ci-après dénommé le « Contractant »</em><br/>
            D'une part,
        </p>

        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>
            IL A ETE CONVENU ET ARRETE CE QUI SUIT
        </p>

        <h4>ARTICLE 1 : Engagement</h4>
        <p>
            La Société GO & DEV DELIVERY CENTER engage le contractant, à compter du {dateDebut || '............'},
            en sa qualité de <strong>{poste}</strong>, et ce dans le cadre d’un contrat à durée indéterminée (CDI), avec une<strong> période
            d’essai de 3 mois renouvelable par tacite reconduction une seule fois</strong>.
        </p>
        <p>
            Le Contractant a la qualification de CADRE et sera notamment chargé de :<br/>
            • La conception, le développement et la maintenance des projets applicatifs qui lui seront confiés.
        </p>

        <h4>ARTICLE 2 : Lieu d'exécution du contrat</h4>
        <p>
            Le contractant exercera ses fonctions au siège de la société. Il pourra effectuer des déplacements
            pour le compte de la société au Maroc et à l’étranger.
        </p>

        <h4 style={{ marginTop: '20px' }}>ARTICLE 3 : Durée du travail</h4>
        <p>L’horaire de travail est de 44 heures hebdomadaire.</p>

        <h4>ARTICLE 4 : Rémunération</h4>
        <p>
            En contrepartie de son travail, le contractant percevra une rémunération fixe mensuelle nette de {salaire} DHs ({salaireLettre} dirhams net)..
        </p>

        <h4>ARTICLE 5 : Exclusivité, Non concurrence</h4>
        <p>
            Le contractant déclare être libre de tout engagement et en conformité avec la législation du travail, s’engage à informer
            la société de tout changement de situation personnelle et à ne pas exercer une activité professionnelle concurrente.
        </p>

        <h4>ARTICLE 6 : Obligation de confidentialité</h4>
        <p>
            Les fonctions confiées au salarié l’obligent à préserver les intérêts de la société et garder confidentielles
            toutes les informations.
        </p>

        <h4>ARTICLE 7 : Rupture du contrat</h4>
        <p>
            Le contrat peut être résilié par chaque partie selon les dispositions légales en vigueur. Un préavis de 2 mois est requis.
        </p>

        <h4>ARTICLE 8 : Dispositions légales et réglementaires</h4>
        <p>
            Les parties s’engagent à se conformer aux dispositions du droit du travail marocain pour toutes les questions non prévues.
        </p>

        <h4>ARTICLE 9 : Élections de domicile et Compétence</h4>
        <p>
            Toute contestation relèvera des tribunaux de Rabat.<br/>
            Le présent contrat est établi en 2 exemplaires.<br/>
            Fait à Rabat le {date || '…/…/……'}.
        </p>

        <div style={{ position: 'absolute', bottom: '-275mm', width: '100%' }}>
            <table style={{ width: '100%' }}>
                <tbody>
                <tr>
                    <td>Le contractant</td>
                    <td style={{ textAlign: 'right' }}>
                        Société GO&DEV DELIVERY CENTER<br />
                        Représentée par Mr Rellier
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

    </div>
);

export default ContratCDI;
